import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton, scrollToCompra } from './Shared';
export const Hero = () => {
  return <section className="relative pt-16 pb-12 md:pt-24 md:pb-20 px-4 overflow-hidden" data-id="element-61">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[500px] bg-grass-500/15 blur-[120px] rounded-full pointer-events-none" data-id="element-62" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[400px] bg-forest-500/15 blur-[120px] rounded-full pointer-events-none" data-id="element-63" />

      <div className="max-w-4xl mx-auto relative z-10 text-center flex flex-col items-center gap-10" data-id="element-64">
        <motion.h1 initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="font-anton text-4xl md:text-5xl lg:text-6xl leading-[1.1] text-white uppercase tracking-wide max-w-3xl" data-id="element-65">
          Convertite en el arquero que{' '}
          <span className="text-grass-400" data-id="element-66">salva al equipo</span> cuando más lo
          necesita
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} onClick={scrollToCompra} className="cursor-pointer w-full max-w-2xl" data-id="element-67">
          <img src="https://cdn.magicpatterns.com/uploads/qHttqE6tY5gAoDMtKKdfjE/TRANSFORMA_TU_PRACTICA_ORTOPEDICA_AL_SIGUIENTE_NIVEL_(1).png" alt="Arquero PRO System - Producto completo" className="w-full h-auto object-contain drop-shadow-[0_20px_50px_rgba(130,194,72,0.25)] hover:drop-shadow-[0_20px_60px_rgba(130,194,72,0.35)] transition-all duration-300 hover:scale-[1.02]" data-id="element-68" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-69">
          <CTAButton data-id="element-70">Quiero mejorar mi nivel →</CTAButton>
        </motion.div>
      </div>
    </section>;
};